import states from './states';

// Event types

const ADD_DEPENDENT = 'ADD_DEPENDENT';
const ADD_DEPENDENTS = 'ADD_DEPENDENT(S)';
const ADOPTION = 'ADOPTION';
const BIRTH = 'BIRTH';
const BIRTH_ADOPTION = 'BIRTH_ADOPTION';
const BIRTH_OR_ADOPTION = 'BIRTH_OR_ADOPTION';
const CHANGE_IN_ADDRESS = 'CHANGE_IN_ADDRESS';
const CHANGE_IN_ADDRESS_FUTURE = 'CHANGE_IN_ADDRESS_FUTURE';
const CHANGE_IN_ADDRESS_WITHIN_STATE = 'CHANGE_IN_ADDRESS_WITHIN_STATE';
const CHANGE_IN_AI_AN_STATUS =
    'CHANGE_IN_AMERICAN INDIAN / ALASKA NATIVE STATUS';
const CHANGE_IN_CITIZENSHIP = 'CHANGE_IN_CITIZENSHIP';
const CHANGE_IN_HOUSEHOLD_SIZE = 'CHANGE_IN_HOUSEHOLD_SIZE';
const CHANGE_IN_INCARCERATION = 'CHANGE_IN_INCARCERATION';
const CHANGE_IN_INCOME = 'CHANGE_IN_INCOME';
const CHANGE_IN_LEGAL_PRESENCE = 'CHANGE_IN_LEGAL_PRESENCE';
const CHANGE_IN_TRIBE_STATUS = 'CHANGE_IN_TRIBE_STATUS';
const CHILD_AGED_OUT_FROM_OLD_APPLICATION =
    'CHILD_AGED_OUT_FROM_OLD_APPLICATION';
const DEATH = 'DEATH';
const DEATH_OF_PTF_OR_SUBSCRIBER = 'DEATH_OF_PTF_OR_SUBSCRIBER';
const DIVORCE = 'DIVORCE';
const DIVORCE_OR_ANULLMENT = 'DIVORCE_OR_ANULLMENT';
const EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE =
    'EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE';
const ERROR_ASSISTER_BROKER = 'ERROR_ASSISTER_BROKER';
const ERROR_DUE_TO_ASSISTER_OR_BROKER = 'ERROR_DUE_TO_ASSISTER_OR_BROKER';
const ERROR_DUE_TO_EXCHANGE = 'ERROR_DUE_TO_EXCHANGE';
const ERROR_EXCHANGE = 'ERROR_EXCHANGE';
const ERROR_HEALTH_PLAN_VIOLATION = 'ERROR_HEALTH_PLAN_VIOLATION';
const ERROR_PLAN_BENEFIT_DISPLAY = 'ERROR_PLAN_BENEFIT_DISPLAY';
const ERROR_PLAN_OR_BENEFIT_DISPLAY = 'ERROR_PLAN_OR_BENEFIT_DISPLAY';
const EXCEPTIONAL_CIRCUMSTANCES_INDIVIDUAL =
    'EXCEPTIONAL_CIRCUMSTANCES_INDIVIDUAL';
const EXCEPTIONAL_CIRCUMSTANCES_NATURAL_DISASTER =
    'EXCEPTIONAL_CIRCUMSTANCES_NATURAL_DISASTER';
const EXCEPTIONAL_CIRCUMSTANCES_OR_PLAN_PROGRAM_ERROR =
    'EXCEPTIONAL_CIRCUMSTANCES_OR_PLAN/PROGRAM_ERROR';
const EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_BACKLOG =
    'EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_BACKLOG';
const EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_ERROR =
    'EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_ERROR';
const EXEMPTION_CANCELLED = 'EXEMPTION_CANCELLED';
const FUTURE_LOSS_OF_MEC = 'FUTURE_LOSS_OF_MEC';
const GAIN_CITIZENSHIP = 'GAIN_CITIZENSHIP';
const GAIN_COURT_APPOINTED_DEPENDENT = 'GAIN_COURT_APPOINTED_DEPENDENT';
const GAIN_IN_TRIBE_STATUS = 'GAIN_IN_TRIBE_STATUS';
const GAIN_LPR = 'GAIN_LPR';
const GAIN_OF_AMERICAN_INDIAN_STATUS = 'GAIN_OF_AMERICAN_INDIAN_STATUS';
const HRA = 'HRA';
const HRA_FUTURE = 'HRA_FUTURE';
const ICHRA_SEP = 'ICHRA_SEP';
const ICHRA_SEP_FUTURE = 'ICHRA_SEP_FUTURE';
const INCARCERATION = 'INCARCERATION';
const INCOME_CHANGE_CSR = 'INCOME_CHANGE_CSR';
const LOSE_COVERAGE_NON_PAYMENT = 'LOSE_COVERAGE_NON_PAYMENT';
const LOSE_COVERAGE_NON_PAYMENT_TYPE4 = 'LOSE_COVERAGE_NON_PAYMENT_TYPE4';
const LOSE_EMPLOYER_COVERAGE = 'LOSE_EMPLOYER_COVERAGE';
const LOSE_EMPLOYER_COVERAGE_TYPE4 = 'LOSE_EMPLOYER_COVERAGE_TYPE4';
const LOSE_OTHER_PUBLIC_MEC = 'LOSE_OTHER_PUBLIC_MEC';
const LOSE_OTHER_PUBLIC_MEC_TYPE4 = 'LOSE_OTHER_PUBLIC_MEC_TYPE4';
const LOSS_OF_COVERAGE_THROUGH_EMPLOYER = 'LOSS_OF_COVERAGE_THROUGH_EMPLOYER';
const LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE =
    'LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE';
const LOSS_OF_MEC = 'LOSS_OF_MEC';
const LOSS_OF_MEC_FUTURE = 'LOSS_OF_MEC_FUTURE';
const LOSS_OF_MEDICAID = 'LOSS_OF_MEDICAID';
const LOSS_OF_MEDICAID_FUTURE = 'LOSS_OF_MEDICAID_FUTURE';
const LOST_OTHER_MIN_ESSENTIAL_COVERAGE = 'LOST_OTHER_MIN_ESSENTIAL_COVERAGE';
const LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE =
    'LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE';
const MARRIAGE = 'MARRIAGE';
const MOVED_INTO_STATE = 'MOVED_INTO_STATE';
const MOVED_INTO_STATE_FUTURE = 'MOVED_INTO_STATE_FUTURE';
const NEWLY_ELIG_FOR_APTC = 'NEWLY_ELIG_FOR_APTC';
const NOT_INCARCERATED = 'NOT_INCARCERATED';
const OTHER_EXCEPTIONAL_CIRCUMSTANCES = 'OTHER_EXCEPTIONAL_CIRCUMSTANCES';
const PRIMARY_GAIN_OF_MEC = 'PRIMARY_GAIN_OF_MEC';
const PRIMARY_GAIN_OF_MEC_FUTURE = 'PRIMARY_GAIN_OF_MEC_FUTURE';
const QSEHRA_SEP = 'QSEHRA_SEP';
const QSEHRA_SEP_FUTURE = 'QSEHRA_SEP_FUTURE';
const REMOVE_DEPENDENT = 'REMOVE_DEPENDENT';
const SURVIVOR_OF_DOMESTIC_ABUSE_OR_SPOUSAL_ABANDONMENT =
    'SURVIVOR_OF_DOMESTIC_ABUSE_OR_SPOUSAL_ABANDONMENT';
export const UNSUPPORTED_EVENT = 'UNSUPPORTED_EVENT';

// Category types

const ADDRESS_PROOF = 'ADDRESS_PROOF';
const CURRENT_ADDRESS_PROOF = 'CURRENT_ADDRESS_PROOF';
const DOC_INDICATING_ADD_REMOVE_OF_DEP = 'DOC_INDICATING_ADD_REMOVE_OF_DEP';
const DOC_INDICATING_EXCEPTIONS = 'DOC_INDICATING_EXCEPTIONS';
const DOC_INDICATING_PROOF_OF_DEATH = 'DOC_INDICATING_PROOF_OF_DEATH';
const DOC_PROVING_EVENT = 'DOC_PROVING_EVENT';
const EXCHANGE_CONFIRMATION_OF_APTC = 'EXCHANGE_CONFIRMATION_OF_APTC';
const IDENTIFICATION = 'IDENTIFICATION';
const PROOF_OF_AIAN = 'PROOF_OF_AIAN';
const PROOF_OF_CONFIRM_CONVICTION_DISPOSITION =
    'PROOF_OF_CONFIRM_CONVICTION_DISPOSITION';
const PROOF_OF_CURRENT_LEGAL_STATUS = 'PROOF_OF_CURRENT_LEGAL_STATUS';
const PROOF_OF_EMPLOYER_PLAN = 'PROOF_OF_EMPLOYER_PLAN';
const PROOF_OF_EXISTING_COVERAGE = 'PROOF_OF_EXISTING_COVERAGE';
const PROOF_OF_HRA = 'PROOF_OF_HRA';
const PROOF_OF_HRA_OFFER = 'PROOF_OF_HRA_OFFER';
const PROOF_OF_INCARCERATION_STATUS = 'PROOF_OF_INCARCERATION_STATUS';
const PROOF_OF_INCOME_CHANGE = 'PROOF_OF_INCOME_CHANGE';
const PROOF_OF_LEGAL_STATUS = 'PROOF_OF_LEGAL_STATUS';
const PROOF_OF_LOSS_OF_COVERAGE = 'PROOF_OF_LOSS_OF_COVERAGE';
const PROOF_OF_LOSS_OF_DEPENDENT = 'PROOF_OF_LOSS_OF_DEPENDENT';
const PROOF_OF_MARRIAGE = 'PROOF_OF_MARRIAGE';
const PROOF_OF_UNAAFFORDABLE_ESI = 'PROOF_OF_UNAAFFORDABLE_ESI';

// Document types

const ABROAD_BIRTH = 'ABROAD_BIRTH';
const ACT_2000_BIRTH = 'ACT_2000_BIRTH';
const ADMIN_STAY_DHS = 'ADMIN_STAY_DHS';
const ADOPTION_DECREE = 'ADOPTION_DECREE';
const AFFIDAVIT_MARRIAGE = 'AFFIDAVIT_MARRIAGE';
const APTC_ELIG_CONFIRM_LETTER = 'APTC_ELIG_CONFIRM_LETTER';
const AUTOMOBILE_REGISTRATION = 'AUTOMOBILE_REGISTRATION';
const BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE';
const C6_MARRIAGE = 'C6_MARRIAGE';
const CENSUS_REC_BIRTH = 'CENSUS_REC_BIRTH';
const CERT_CITIZENSHIP = 'CERT_CITIZENSHIP';
const CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA = 'CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA';
const CERT_OF_NATURALIZATION = 'CERT_OF_NATURALIZATION';
const CERT_OF_US_CITIZENSHIP = 'CERT_OF_US_CITIZENSHIP';
const CIRT_REPORTING_BIRTH = 'CIRT_REPORTING_BIRTH';
const COBRA_COV = 'COBRA_COV';
const COLLEGE_ENROLLMENT_LETTER = 'COLLEGE_ENROLLMENT_LETTER';
const CONFIRM_CONVICTION_DISP_CHARGES = 'CONFIRM_CONVICTION_DISP_CHARGES';
const COURT_ORDER_INDICATING_ADD_REMOVE = 'COURT_ORDER_INDICATING_ADD_REMOVE';
const COURT_ORDER_PETITION_NAME_CHANGE = 'COURT_ORDER_PETITION_NAME_CHANGE';
const CTZN_ID_CARD = 'CTZN_ID_CARD';
const DEATH_CERTIFICATE = 'DEATH_CERTIFICATE';
const DENIAL_LETTER_FROM_YOUR_STATE = 'DENIAL_LETTER_FROM_YOUR_STATE';
const DIVORCE_DECREE = 'DIVORCE_DECREE';
const DOC_INDICATING_LEGAL_STATUS = 'DOC_INDICATING_LEGAL_STATUS';
const DOC_REFUGEE_SETTLEMENT = 'DOC_REFUGEE_SETTLEMENT';
const DOC_SUPPORTING_EVENT = 'DOC_SUPPORTING_EVENT';
const DOC_WITHHOLD_REMOVAL = 'DOC_WITHHOLD_REMOVAL';
const DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DEATH = 'DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DEATH';
const DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DIVORCE_SEPARATION = 'DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DIVORCE_SEPARATION';
const DOMESTIC_LEGAL_DOCUMENT = 'DOMESTIC_LEGAL_DOCUMENT';
const DS2019 = 'DS2019';
const DRIVER_LICENSE = 'DRIVER_LICENSE';
const EMPLYR_CONTRI_TERM_FRM_COBRA = 'EMPLYR_CONTRI_TERM_FRM_COBRA';
const EMPLYR_CONTRI_TERM_FRM_EMPLYR = 'EMPLYR_CONTRI_TERM_FRM_EMPLYR';
const EMPLYR_COVERAGE_OFFER = 'EMPLYR_COVERAGE_OFFER';
const ESC_EMPLOYER_PLAN_DETAILS = 'ESC_EMPLOYER_PLAN_DETAILS';
const EXHAUSTION_OF_COBRA_BENEFITS = 'EXHAUSTION_OF_COBRA_BENEFITS';
const FUND_EXHAUSTION_FM_PERSI = 'FUND_EXHAUSTION_FM_PERSI';
const GOV_LETTER_GOV = 'GOV_LETTER_GOV';
const GOVT_LETTER_ADDR = 'GOVT_LETTER_ADDR';
const HEALTH_CARE_PROGRAM_DOCUMENT = 'HEALTH_CARE_PROGRAM_DOCUMENT';
const HEALTH_INSURANCE_PROOF = 'HEALTH_INSURANCE_PROOF';
const HOME_PAYMENT_NOTICE = 'HOME_PAYMENT_NOTICE';
const HOME_PURCHASE_AGREEMENT = 'HOME_PURCHASE_AGREEMENT';
const HRA_EMPLOYER_NOTICE = 'HRA_EMPLOYER_NOTICE';
const HRA_OFFER_DOCUMENT = 'HRA_OFFER_DOCUMENT';
const I20 = 'I20';
const I94 = 'I94';
const I94_UNEXP = 'I94_UNEXP';
const I327 = 'I327';
const I360 = 'I360';
const I551 = 'I551';
const I571 = 'I571';
const I688 = 'I688';
const I688A = 'I688A';
const I688B = 'I688B';
const I766 = 'I766';
const INCOME_1040 = '1040_INCOME';
const INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE =
    'INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE';
const INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE_FUTURE =
    'INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE_FUTURE';
const INCREASE_IN_SUBSIDY_INCOME_CHANGE = 'INCREASE_IN_SUBSIDY_INCOME_CHANGE';
const INSURANCE_LETTER_ADDR = 'INSURANCE_LETTER_ADDR';
const INSURANCE_LETTER_COV = 'INSURANCE_LETTER_COV';
const LEGAL_SEPARATION_DOC = 'LEGAL_SEPARATION_DOC';
const LETTER_ABOUT_COBRA_COVERAGE = 'LETTER_ABOUT_COBRA_COVERAGE';
const LETTER_FOR_LOSS_OF_STUDENT_COVERAGE = 'LETTER_FOR_LOSS_OF_STUDENT_COVERAGE';
const LETTER_FROM_A_GOVERNMENT_ORGANIZATION = 'LETTER_FROM_A_GOVERNMENT_ORGANIZATION';
const LETTER_FROM_AN_EMPLOYER = 'LETTER_FROM_AN_EMPLOYER';
const LETTER_OF_EXPLANATION = 'LETTER_OF_EXPLANATION';
const LETTER_STATING_LOST_COVERAGE = 'LETTER_STATING_LOST_COVERAGE';
const MARINAS_ID_CARD = 'MARINAS_ID_CARD';
const MARKETPLACE_COV = 'MARKETPLACE_COV';
const MARKETPLACE_LETTER = 'MARKETPLACE_LETTER';
const MARRIAGE_CERTIFICATE = 'MARRIAGE_CERTIFICATE';
const MEDICAL_CONDITIONS = 'MEDICAL_CONDITIONS';
const MEDICAL_RECORDS_BIRTH = 'MEDICAL_RECORDS_BIRTH';
const MIL_RECORD_BIRTH = 'MIL_RECORD_BIRTH';
const MORTGAGE_DOCUMENT = 'MORTGAGE_DOCUMENT';
const MOVED_INTO_THE_US = 'MOVED_INTO_THE_US';
const OBITUARY = 'OBITUARY';
const OFFER_OF_EMPLOYMENT = 'OFFER_OF_EMPLOYMENT';
const OTHER = 'OTHER';
const OTHER_EXCEPTIONS = 'OTHER_EXCEPTIONS';
const PASS_CARD = 'PASS_CARD';
const PASSPORT_CARD = 'PASSPORT_CARD';
const PAY_STUB_COV = 'PAY_STUB_COV';
const PAY_STUB_INCOME = 'PAY_STUB_INCOME';
const PAY_STUBS = 'PAY_STUBS';
const PBLC_RCRD_MARRIAGE = 'PBLC_RCRD_MARRIAGE';
const PRIOR_EMPLYR_LOSS_OF_COVERAGE = 'PRIOR_EMPLYR_LOSS_OF_COVERAGE';
const PROOF_OF_INCOME = 'PROOF_OF_INCOME';
const PROPERTY_TAX_NOTICE = 'PROPERTY_TAX_NOTICE';
const REF_LETTER_ADDR = 'REF_LETTER_ADDR';
const RELEGIOUS_REC_BIRTH = 'RELEGIOUS_REC_BIRTH';
const RENTAL_AGREEMENT = 'RENTAL_AGREEMENT';
const REPORT_TO_MILITARY_DUTY = 'REPORT_TO_MILITARY_DUTY';
const RESIDENT_ALIEN_CARD = 'RESIDENT_ALIEN_CARD';
const SCHOOL_REC_BIRTH = 'SCHOOL_REC_BIRTH';
const SCREENSHOT_OF_RESULTS = 'SCREENSHOT_OF_RESULTS';
const SELF_EMP_INCOME = 'SELF_EMP_INCOME';
const SIGNED_AFFIDAVIT = 'SIGNED_AFFIDAVIT';
const SPECIAL_CIRCUMSTANCE_ATTESTATION = 'SPECIAL_CIRCUMSTANCE_ATTESTATION';
const SSA_INCOME = 'SSA_INCOME';
const STAR_CARD = 'STAR_CARD';
const STATE_ISSUED_ID = 'STATE_ISSUED_ID';
const STUDENT_LETTER_COV = 'STUDENT_LETTER_COV';
const TECHNICAL_ISSUE = 'TECHNICAL_ISSUE';
const TEMP_I551_STAMP = 'TEMP_I551_STAMP';
const TERM_LETTER_FROM_CARRIER = 'TERM_LETTER_FROM_CARRIER';
const TERM_LETTER_FROM_GOV_PROVIDER = 'TERM_LETTER_FROM_GOV_PROVIDER';
const TRIBAL_BIRTH = 'TRIBAL_BIRTH';
const TRIBAL_DOCUMENT = 'TRIBAL_DOCUMENT';
const TRIBAL_MEMBERSHIP = 'TRIBAL_MEMBERSHIP';
const UNEMP_INCOME = 'UNEMP_INCOME';
const UNEXP_PASSPORT = 'UNEXP_PASSPORT';
const US_BIRTH_CERTIFICATE = 'US_BIRTH_CERTIFICATE';
const US_CIVIL_SERVICES_BIRTH = 'US_CIVIL_SERVICES_BIRTH';
const US_PASSPORT = 'US_PASSPORT';
const US_POSTAL_LETTER = 'US_POSTAL_LETTER';
const UTILITY_BILLS = 'UTILITY_BILLS';
const VALIDATION_ON_ID_REPOSITORY = 'VALIDATION_ON_ID_REPOSITORY';
const VERIFICATION_OF_TIME_SERVED = 'VERIFICATION_OF_TIME_SERVED';
const VOTER_CARD = 'VOTER_CARD';
const W2_INCOME = 'W2_INCOME';

const getIdahoConfig = () => {
    const PROOF_OF_EXISTING_COVERAGE_CATEGORY = {
        categoryType: PROOF_OF_EXISTING_COVERAGE,
        documentsQty: 1,
        documentTypes: [
            EXHAUSTION_OF_COBRA_BENEFITS,
            HEALTH_INSURANCE_PROOF
        ],
    };

    const IDENTIFICATION_CATEGORY = {
        categoryType: IDENTIFICATION,
        documentsQty: 1,
        documentTypes: [
            US_PASSPORT,
            PASSPORT_CARD,
            STAR_CARD,
            STATE_ISSUED_ID,
            DRIVER_LICENSE,
            VOTER_CARD,
        ],
    };

    const ADDRESS_PROOF_CATEGORY = {
        categoryType: ADDRESS_PROOF,
        documentsQty: 2,
        documentTypes: [
            COLLEGE_ENROLLMENT_LETTER,
            AUTOMOBILE_REGISTRATION,
            RENTAL_AGREEMENT,
            HOME_PURCHASE_AGREEMENT,
            UTILITY_BILLS,
            HOME_PAYMENT_NOTICE,
            PROPERTY_TAX_NOTICE,
            OFFER_OF_EMPLOYMENT,
        ],
    };

    const CURRENT_ADDRESS_PROOF_CATEGORY = {
        categoryType: CURRENT_ADDRESS_PROOF,
        documentsQty: 1,
        documentTypes: [
            ...ADDRESS_PROOF_CATEGORY.documentTypes
        ],
    };

    const config = new Map();

    config.set(
        [
            CHANGE_IN_ADDRESS_WITHIN_STATE,
            MOVED_INTO_STATE
        ],
        {
            documents: [
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
                IDENTIFICATION_CATEGORY,
                ADDRESS_PROOF_CATEGORY,
            ],
        }
    );

    config.set(
        [
            MARRIAGE,
            DIVORCE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_MARRIAGE,
                    documentsQty: 1,
                    documentTypes: [
                        MARRIAGE_CERTIFICATE,
                        COURT_ORDER_PETITION_NAME_CHANGE,
                        DOMESTIC_LEGAL_DOCUMENT,
                        VALIDATION_ON_ID_REPOSITORY,
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
            ],
        }
    );

    config.set(
        [
            DEATH_OF_PTF_OR_SUBSCRIBER,
            DEATH
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_PROOF_OF_DEATH,
                    documentsQty: 1,
                    documentTypes: [
                        DEATH_CERTIFICATE,
                        SIGNED_AFFIDAVIT,
                        OBITUARY
                    ],
                },
            ],
        }
    );

    config.set(
        [
            CHANGE_IN_AI_AN_STATUS,
            CHANGE_IN_TRIBE_STATUS,
            GAIN_IN_TRIBE_STATUS,
            GAIN_OF_AMERICAN_INDIAN_STATUS,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_AIAN,
                    documentsQty: 1,
                    documentTypes: [
                        CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA,
                        TRIBAL_MEMBERSHIP,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            CHANGE_IN_HOUSEHOLD_SIZE,
            BIRTH,
            BIRTH_ADOPTION,
            ADD_DEPENDENT,
            ADD_DEPENDENTS,
            ADOPTION,
            GAIN_COURT_APPOINTED_DEPENDENT,
            REMOVE_DEPENDENT,
            BIRTH_OR_ADOPTION,
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_ADD_REMOVE_OF_DEP,
                    documentsQty: 1,
                    documentTypes: [
                        BIRTH_CERTIFICATE,
                        COURT_ORDER_INDICATING_ADD_REMOVE,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            LOSS_OF_MEC,
            LOSE_COVERAGE_NON_PAYMENT,
            LOSE_COVERAGE_NON_PAYMENT_TYPE4,
            LOSE_EMPLOYER_COVERAGE,
            LOSE_EMPLOYER_COVERAGE_TYPE4,
            LOSE_OTHER_PUBLIC_MEC,
            LOSE_OTHER_PUBLIC_MEC_TYPE4,
            LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE,
            LOSS_OF_MEC_FUTURE,
            LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
            PRIMARY_GAIN_OF_MEC,
            PRIMARY_GAIN_OF_MEC_FUTURE,
            CHILD_AGED_OUT_FROM_OLD_APPLICATION,
            EXEMPTION_CANCELLED,
            LOSS_OF_MEDICAID,
            LOSS_OF_MEDICAID_FUTURE,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_LOSS_OF_COVERAGE,
                    documentsQty: 1,
                    documentTypes: [
                        TERM_LETTER_FROM_CARRIER,
                        TERM_LETTER_FROM_GOV_PROVIDER,
                        EMPLYR_CONTRI_TERM_FRM_COBRA,
                        EMPLYR_CONTRI_TERM_FRM_EMPLYR,
                        FUND_EXHAUSTION_FM_PERSI,
                        PRIOR_EMPLYR_LOSS_OF_COVERAGE,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            CHANGE_IN_INCARCERATION,
            INCARCERATION,
            NOT_INCARCERATED
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_INCARCERATION_STATUS,
                    documentsQty: 1,
                    documentTypes: [
                        VERIFICATION_OF_TIME_SERVED
                    ],
                },
                {
                    categoryType: PROOF_OF_CONFIRM_CONVICTION_DISPOSITION,
                    documentsQty: 1,
                    documentTypes: [
                        CONFIRM_CONVICTION_DISP_CHARGES
                    ],
                },
            ],
        }
    );

    config.set(
        [
            NEWLY_ELIG_FOR_APTC,
            INCOME_CHANGE_CSR,
            CHANGE_IN_INCOME
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_INCOME_CHANGE,
                    documentsQty: 1,
                    documentTypes: [
                        PROOF_OF_INCOME
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
                {
                    categoryType: EXCHANGE_CONFIRMATION_OF_APTC,
                    documentsQty: 1,
                    documentTypes: [
                        APTC_ELIG_CONFIRM_LETTER
                    ],
                },
            ],
        }
    );

    config.set(
        [
            OTHER_EXCEPTIONAL_CIRCUMSTANCES
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_EXCEPTIONS,
                    documentsQty: 1,
                    documentTypes: [
                        REPORT_TO_MILITARY_DUTY,
                        MEDICAL_CONDITIONS,
                        TECHNICAL_ISSUE,
                        OTHER_EXCEPTIONS,
                    ],
                },
            ],
        }
    );

    config.set(
        [
            CHANGE_IN_LEGAL_PRESENCE,
            CHANGE_IN_CITIZENSHIP,
            GAIN_CITIZENSHIP,
            GAIN_LPR,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_LEGAL_STATUS,
                    documentsQty: 1,
                    documentTypes: [
                        US_PASSPORT,
                        PASSPORT_CARD,
                        CERT_OF_NATURALIZATION,
                        CERT_OF_US_CITIZENSHIP,
                        TRIBAL_DOCUMENT,
                        US_BIRTH_CERTIFICATE,
                        RESIDENT_ALIEN_CARD,
                        DOC_INDICATING_LEGAL_STATUS,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            CHANGE_IN_ADDRESS
        ],
        {
            documents: [
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
                IDENTIFICATION_CATEGORY,
                CURRENT_ADDRESS_PROOF_CATEGORY,
            ],
        }
    );

    config.set(
        [
            EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_UNAAFFORDABLE_ESI,
                    documentsQty: 1,
                    documentTypes: [
                        EMPLYR_COVERAGE_OFFER
                    ],
                },
            ],
        }
    );

    config.set(
        [
            ICHRA_SEP,
            ICHRA_SEP_FUTURE,
            QSEHRA_SEP,
            QSEHRA_SEP_FUTURE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_HRA_OFFER,
                    documentsQty: 1,
                    documentTypes: [
                        HRA_OFFER_DOCUMENT
                    ]
                }
            ]
        }
    );

    config.set(
        [
            UNSUPPORTED_EVENT
        ],
        {
            documents: [
                {
                    categoryType: DOC_PROVING_EVENT,
                    documentsQty: 1,
                    documentTypes: [
                        DOC_SUPPORTING_EVENT
                    ],
                },
            ],
        }
    );

    return config;
};

const getPennsylvaniaConfig = () => {
    const PROOF_OF_EXISTING_COVERAGE_CATEGORY = {
        categoryType: PROOF_OF_EXISTING_COVERAGE,
        documentsQty: 1,
        documentTypes: [
            INSURANCE_LETTER_COV,
            GOV_LETTER_GOV,
            COBRA_COV,
            PAY_STUB_COV,
            MARKETPLACE_COV,
            STUDENT_LETTER_COV,
        ],
    };

    const config = new Map();

    config.set(
        [
            CHANGE_IN_ADDRESS,
            CHANGE_IN_ADDRESS_FUTURE,
            MOVED_INTO_STATE,
            MOVED_INTO_STATE_FUTURE,
        ],
        {
            documents: [
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
                {
                    categoryType: ADDRESS_PROOF,
                    documentsQty: 1,
                    documentTypes: [
                        US_POSTAL_LETTER,
                        MORTGAGE_DOCUMENT,
                        RENTAL_AGREEMENT,
                        MOVED_INTO_THE_US,
                        VOTER_CARD,
                        INSURANCE_LETTER_ADDR,
                        UTILITY_BILLS,
                        GOVT_LETTER_ADDR,
                        REF_LETTER_ADDR,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            MARRIAGE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_MARRIAGE,
                    documentsQty: 1,
                    documentTypes: [
                        C6_MARRIAGE,
                        AFFIDAVIT_MARRIAGE,
                        MARRIAGE_CERTIFICATE,
                        PBLC_RCRD_MARRIAGE,
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
            ],
        }
    );

    config.set(
        [
            DIVORCE,
            DIVORCE_OR_ANULLMENT
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_LOSS_OF_DEPENDENT,
                    documentsQty: 1,
                    documentTypes: [
                        LEGAL_SEPARATION_DOC,
                        DIVORCE_DECREE
                    ],
                },
            ],
        }
    );

    config.set(
        [
            HRA,
            HRA_FUTURE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_HRA,
                    documentsQty: 1,
                    documentTypes: [
                        HRA_EMPLOYER_NOTICE
                    ],
                },
            ],
        }
    );

    config.set(
        [
            EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE,
            INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE,
            INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE_FUTURE,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_EMPLOYER_PLAN,
                    documentsQty: 1,
                    documentTypes: [
                        ESC_EMPLOYER_PLAN_DETAILS
                    ],
                },
            ],
        },
    );

    config.set(
        [
            ERROR_ASSISTER_BROKER,
            ERROR_DUE_TO_ASSISTER_OR_BROKER,
            ERROR_DUE_TO_EXCHANGE,
            ERROR_EXCHANGE,
            ERROR_HEALTH_PLAN_VIOLATION,
            ERROR_PLAN_BENEFIT_DISPLAY,
            ERROR_PLAN_OR_BENEFIT_DISPLAY,
            EXCEPTIONAL_CIRCUMSTANCES_INDIVIDUAL,
            EXCEPTIONAL_CIRCUMSTANCES_NATURAL_DISASTER,
            EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_BACKLOG,
            EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_ERROR,
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_EXCEPTIONS,
                    documentsQty: 1,
                    documentTypes: [
                        OTHER_EXCEPTIONS
                    ],
                },
            ],
        },
    );

    config.set(
        [
            SURVIVOR_OF_DOMESTIC_ABUSE_OR_SPOUSAL_ABANDONMENT
        ],
        {
            documents: [
                PROOF_OF_EXISTING_COVERAGE_CATEGORY
            ],
        }
    );

    config.set(
        [
            INCREASE_IN_SUBSIDY_INCOME_CHANGE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_INCOME_CHANGE,
                    documentsQty: 1,
                    documentTypes: [
                        INCOME_1040,
                        W2_INCOME,
                        PAY_STUB_INCOME,
                        SELF_EMP_INCOME,
                        SSA_INCOME,
                        UNEMP_INCOME,
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
            ],
        }
    );

    config.set(
        [
            CHANGE_IN_LEGAL_PRESENCE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_CURRENT_LEGAL_STATUS,
                    documentsQty: 1,
                    documentTypes: [
                        US_PASSPORT,
                        CERT_CITIZENSHIP,
                        I551,
                        I94,
                        I94_UNEXP,
                        CTZN_ID_CARD,
                        DOC_REFUGEE_SETTLEMENT,
                        UNEXP_PASSPORT,
                        I571,
                        BIRTH_CERTIFICATE,
                        I766,
                        I688B,
                        I688A,
                        I688,
                        I20,
                        DS2019,
                        TEMP_I551_STAMP,
                        TRIBAL_BIRTH,
                        ACT_2000_BIRTH,
                        ABROAD_BIRTH,
                        MARINAS_ID_CARD,
                        DRIVER_LICENSE,
                        MIL_RECORD_BIRTH,
                        CENSUS_REC_BIRTH,
                        ADOPTION_DECREE,
                        MEDICAL_RECORDS_BIRTH,
                        US_CIVIL_SERVICES_BIRTH,
                        CIRT_REPORTING_BIRTH,
                        PASS_CARD,
                        SCHOOL_REC_BIRTH,
                        I327,
                        I360,
                        DOC_WITHHOLD_REMOVAL,
                        ADMIN_STAY_DHS,
                        RELEGIOUS_REC_BIRTH,
                    ],
                },
            ],
        }
    );

    config.set(
        [
            ICHRA_SEP,
            ICHRA_SEP_FUTURE,
            QSEHRA_SEP,
            QSEHRA_SEP_FUTURE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_HRA_OFFER,
                    documentsQty: 1,
                    documentTypes: [
                        HRA_OFFER_DOCUMENT
                    ]
                }
            ]
        }
    );

    config.set(
        [
            UNSUPPORTED_EVENT
        ],
        {
            documents: [
                {
                    categoryType: DOC_PROVING_EVENT,
                    documentsQty: 1,
                    documentTypes: [
                        DOC_SUPPORTING_EVENT
                    ],
                },
            ],
        }
    );

    return config;
};

const getNevadaConfig = () => {
    const config = new Map();

    const PROOF_OF_EXISTING_COVERAGE_CATEGORY = {
        categoryType: PROOF_OF_EXISTING_COVERAGE,
        documentsQty: 1,
        documentTypes: [
            EXHAUSTION_OF_COBRA_BENEFITS,
            HEALTH_INSURANCE_PROOF
        ],
    };

    const IDENTIFICATION_CATEGORY = {
        categoryType: IDENTIFICATION,
        documentsQty: 1,
        documentTypes: [
            US_PASSPORT,
            DRIVER_LICENSE,
            VOTER_CARD
        ],
    };

    const ADDRESS_PROOF_CATEGORY = {
        categoryType: ADDRESS_PROOF,
        documentsQty: 2,
        documentTypes: [
            COLLEGE_ENROLLMENT_LETTER,
            AUTOMOBILE_REGISTRATION,
            RENTAL_AGREEMENT,
            HOME_PURCHASE_AGREEMENT,
            UTILITY_BILLS,
            HOME_PAYMENT_NOTICE,
            PROPERTY_TAX_NOTICE,
            OFFER_OF_EMPLOYMENT,
        ],
    };

    config.set(
        [
            CHANGE_IN_ADDRESS,
            MOVED_INTO_STATE
        ],
        {
            documents: [
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
                IDENTIFICATION_CATEGORY,
                ADDRESS_PROOF_CATEGORY,
            ],
        }
    );

    config.set(
        [
            MARRIAGE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_MARRIAGE,
                    documentsQty: 1,
                    documentTypes: [
                        MARRIAGE_CERTIFICATE,
                        COURT_ORDER_PETITION_NAME_CHANGE,
                        DOMESTIC_LEGAL_DOCUMENT,
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
            ],
        }
    );

    config.set(
        [
            CHANGE_IN_AI_AN_STATUS,
            CHANGE_IN_TRIBE_STATUS,
            GAIN_OF_AMERICAN_INDIAN_STATUS,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_AIAN,
                    documentsQty: 1,
                    documentTypes: [
                        CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA,
                        TRIBAL_MEMBERSHIP,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            CHANGE_IN_HOUSEHOLD_SIZE,
            BIRTH,
            ADOPTION,
            REMOVE_DEPENDENT
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_ADD_REMOVE_OF_DEP,
                    documentsQty: 1,
                    documentTypes: [
                        BIRTH_CERTIFICATE,
                        COURT_ORDER_INDICATING_ADD_REMOVE,
                    ],
                },
            ],
        }
    );

    config.set(
        [
            LOSS_OF_MEC,
            LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE,
            LOSS_OF_MEC_FUTURE,
            LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
            PRIMARY_GAIN_OF_MEC,
            PRIMARY_GAIN_OF_MEC_FUTURE,
            CHILD_AGED_OUT_FROM_OLD_APPLICATION,
            EXEMPTION_CANCELLED,
            LOSS_OF_MEDICAID,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_LOSS_OF_COVERAGE,
                    documentsQty: 1,
                    documentTypes: [
                        TERM_LETTER_FROM_CARRIER,
                        TERM_LETTER_FROM_GOV_PROVIDER,
                        EMPLYR_CONTRI_TERM_FRM_COBRA,
                        EMPLYR_CONTRI_TERM_FRM_EMPLYR,
                        PRIOR_EMPLYR_LOSS_OF_COVERAGE,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            CHANGE_IN_INCARCERATION,
            INCARCERATION
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_INCARCERATION_STATUS,
                    documentsQty: 1,
                    documentTypes: [
                        VERIFICATION_OF_TIME_SERVED
                    ],
                },
                {
                    categoryType: PROOF_OF_CONFIRM_CONVICTION_DISPOSITION,
                    documentsQty: 1,
                    documentTypes: [
                        CONFIRM_CONVICTION_DISP_CHARGES
                    ],
                },
            ],
        }
    );

    config.set(
        [
            INCOME_CHANGE_CSR
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_INCOME_CHANGE,
                    documentsQty: 1,
                    documentTypes: [
                        PROOF_OF_INCOME
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
            ],
        }
    );

    config.set(
        [
            CHANGE_IN_LEGAL_PRESENCE,
            CHANGE_IN_CITIZENSHIP
        ],
        {
            documents: [
                IDENTIFICATION_CATEGORY,
                {
                    ...ADDRESS_PROOF_CATEGORY,
                    mandatoryDocuments: [
                        UTILITY_BILLS
                    ],
                },
            ],
        }
    );

    config.set(
        [
            OTHER_EXCEPTIONAL_CIRCUMSTANCES
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_EXCEPTIONS,
                    documentsQty: 1,
                    documentTypes: [
                        REPORT_TO_MILITARY_DUTY,
                        MEDICAL_CONDITIONS,
                        OTHER_EXCEPTIONS,
                    ],
                },
            ],
        }
    );

    config.set(
        [
            UNSUPPORTED_EVENT
        ],
        {
            documents: [
                {
                    categoryType: DOC_PROVING_EVENT,
                    documentsQty: 1,
                    documentTypes: [
                        DOC_SUPPORTING_EVENT
                    ],
                },
            ],
        }
    );

    return config;
};

const getNewJerseyConfig = () => {
    const config = new Map();

    config.set(
        [
            EXCEPTIONAL_CIRCUMSTANCES_OR_PLAN_PROGRAM_ERROR
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_EXCEPTIONS,
                    documentsQty: 1,
                    documentTypes: [
                        SPECIAL_CIRCUMSTANCE_ATTESTATION
                    ],
                },
            ],
        }
    );

    config.set(
        [
            UNSUPPORTED_EVENT
        ],
        {
            documents: [
                {
                    categoryType: DOC_PROVING_EVENT,
                    documentsQty: 1,
                    documentTypes: [
                        DOC_SUPPORTING_EVENT
                    ],
                },
            ],
        }
    );

    return config;
};

const getVirginiaConfig = () => {
    const PROOF_OF_EXISTING_COVERAGE_CATEGORY = {
        categoryType: PROOF_OF_EXISTING_COVERAGE,
        documentsQty: 1,
        documentTypes: [
            INSURANCE_LETTER_COV,
            GOV_LETTER_GOV,
            COBRA_COV,
            PAY_STUB_COV,
            MARKETPLACE_COV,
            STUDENT_LETTER_COV,
        ],
    };

    const config = new Map();

    config.set(
        [
            CHANGE_IN_ADDRESS,
            CHANGE_IN_ADDRESS_FUTURE,
            MOVED_INTO_STATE,
            MOVED_INTO_STATE_FUTURE,
        ],
        {
            documents: [
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
                {
                    categoryType: ADDRESS_PROOF,
                    documentsQty: 1,
                    documentTypes: [
                        US_POSTAL_LETTER,
                        MORTGAGE_DOCUMENT,
                        RENTAL_AGREEMENT,
                        MOVED_INTO_THE_US,
                        VOTER_CARD,
                        INSURANCE_LETTER_ADDR,
                        UTILITY_BILLS,
                        GOVT_LETTER_ADDR,
                        REF_LETTER_ADDR,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            LOSS_OF_MEC,
            LOSS_OF_MEDICAID,
            LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_EXISTING_COVERAGE,
                    documentsQty: 1,
                    documentTypes: [
                        INSURANCE_LETTER_COV,
                        GOV_LETTER_GOV, 
                        COBRA_COV,
                        PAY_STUB_COV,
                        MARKETPLACE_COV,
                        STUDENT_LETTER_COV
                    ],
                },
            ],
        },
    );

    config.set(
        [
            MARRIAGE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_MARRIAGE,
                    documentsQty: 1,
                    documentTypes: [
                        C6_MARRIAGE,
                        AFFIDAVIT_MARRIAGE,
                        MARRIAGE_CERTIFICATE,
                        PBLC_RCRD_MARRIAGE,
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
            ],
        }
    );

    config.set(
        [
            DIVORCE,
            DIVORCE_OR_ANULLMENT
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_LOSS_OF_DEPENDENT,
                    documentsQty: 1,
                    documentTypes: [
                        LEGAL_SEPARATION_DOC,
                        DIVORCE_DECREE
                    ],
                },
            ],
        }
    );

    config.set(
        [
            HRA,
            HRA_FUTURE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_HRA,
                    documentsQty: 1,
                    documentTypes: [
                        HRA_EMPLOYER_NOTICE
                    ],
                },
            ],
        }
    );

    config.set(
        [
            EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE,
            INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE,
            INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE_FUTURE,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_EMPLOYER_PLAN,
                    documentsQty: 1,
                    documentTypes: [
                        ESC_EMPLOYER_PLAN_DETAILS
                    ],
                },
            ],
        },
    );

    config.set(
        [
            ERROR_ASSISTER_BROKER,
            ERROR_DUE_TO_ASSISTER_OR_BROKER,
            ERROR_DUE_TO_EXCHANGE,
            ERROR_EXCHANGE,
            ERROR_HEALTH_PLAN_VIOLATION,
            ERROR_PLAN_BENEFIT_DISPLAY,
            ERROR_PLAN_OR_BENEFIT_DISPLAY,
            EXCEPTIONAL_CIRCUMSTANCES_INDIVIDUAL,
            EXCEPTIONAL_CIRCUMSTANCES_NATURAL_DISASTER,
            EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_BACKLOG,
            EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_ERROR,
            EXCEPTIONAL_CIRCUMSTANCES_OR_PLAN_PROGRAM_ERROR,
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_EXCEPTIONS,
                    documentsQty: 1,
                    documentTypes: [
                        OTHER_EXCEPTIONS
                    ],
                },
            ],
        },
    );

    config.set(
        [
            SURVIVOR_OF_DOMESTIC_ABUSE_OR_SPOUSAL_ABANDONMENT
        ],
        {
            documents: [
                PROOF_OF_EXISTING_COVERAGE_CATEGORY
            ],
        }
    );

    config.set(
        [
            INCREASE_IN_SUBSIDY_INCOME_CHANGE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_INCOME_CHANGE,
                    documentsQty: 1,
                    documentTypes: [
                        INCOME_1040,
                        W2_INCOME,
                        PAY_STUB_INCOME,
                        SELF_EMP_INCOME,
                        SSA_INCOME,
                        UNEMP_INCOME,
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
            ],
        }
    );

    config.set(
        [
            CHANGE_IN_LEGAL_PRESENCE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_CURRENT_LEGAL_STATUS,
                    documentsQty: 1,
                    documentTypes: [
                        US_PASSPORT,
                        CERT_CITIZENSHIP,
                        I551,
                        I94,
                        I94_UNEXP,
                        CTZN_ID_CARD,
                        DOC_REFUGEE_SETTLEMENT,
                        UNEXP_PASSPORT,
                        I571,
                        BIRTH_CERTIFICATE,
                        I766,
                        I688B,
                        I688A,
                        I688,
                        I20,
                        DS2019,
                        TEMP_I551_STAMP,
                        TRIBAL_BIRTH,
                        ACT_2000_BIRTH,
                        ABROAD_BIRTH,
                        MARINAS_ID_CARD,
                        DRIVER_LICENSE,
                        MIL_RECORD_BIRTH,
                        CENSUS_REC_BIRTH,
                        ADOPTION_DECREE,
                        MEDICAL_RECORDS_BIRTH,
                        US_CIVIL_SERVICES_BIRTH,
                        CIRT_REPORTING_BIRTH,
                        PASS_CARD,
                        SCHOOL_REC_BIRTH,
                        I327,
                        I360,
                        DOC_WITHHOLD_REMOVAL,
                        ADMIN_STAY_DHS,
                        RELEGIOUS_REC_BIRTH,
                    ],
                },
            ],
        }
    );

    config.set(
        [
            ICHRA_SEP,
            ICHRA_SEP_FUTURE,
            QSEHRA_SEP,
            QSEHRA_SEP_FUTURE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_HRA_OFFER,
                    documentsQty: 1,
                    documentTypes: [
                        HRA_OFFER_DOCUMENT
                    ]
                }
            ]
        }
    );

    config.set(
        [
            UNSUPPORTED_EVENT
        ],
        {
            documents: [
                {
                    categoryType: DOC_PROVING_EVENT,
                    documentsQty: 1,
                    documentTypes: [
                        DOC_SUPPORTING_EVENT
                    ],
                },
            ],
        }
    );

    return config;
};

const getGeorgiaConfig = () => {
    const config = new Map();

    config.set(
        [
            FUTURE_LOSS_OF_MEC,
            LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            LOSS_OF_MEDICAID,
            LOSS_OF_MEC,
            LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            LOSS_OF_MEDICAID_FUTURE,
            LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
            LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_EXISTING_COVERAGE,
                    documentsQty: 1,
                    documentTypes: [
                        DENIAL_LETTER_FROM_YOUR_STATE,
                        HEALTH_CARE_PROGRAM_DOCUMENT,
                        LETTER_ABOUT_COBRA_COVERAGE,
                        LETTER_FOR_LOSS_OF_STUDENT_COVERAGE,
                        LETTER_FROM_A_GOVERNMENT_ORGANIZATION,
                        LETTER_FROM_AN_EMPLOYER,
                        LETTER_OF_EXPLANATION,
                        LETTER_STATING_LOST_COVERAGE,
                        MARKETPLACE_LETTER,
                        SCREENSHOT_OF_RESULTS,
                        DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DEATH,
                        DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DIVORCE_SEPARATION,
                        OTHER,
                        PAY_STUBS
                    ],
                },
            ],
        }
    );

    config.set(
        [
            ICHRA_SEP,
            ICHRA_SEP_FUTURE,
            QSEHRA_SEP,
            QSEHRA_SEP_FUTURE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_HRA_OFFER,
                    documentsQty: 1,
                    documentTypes: [
                        HRA_OFFER_DOCUMENT
                    ]
                }
            ]
        }
    );

    config.set(
        [
            UNSUPPORTED_EVENT
        ],
        {
            documents: [
                {
                    categoryType: DOC_PROVING_EVENT,
                    documentsQty: 1,
                    documentTypes: [
                        DOC_SUPPORTING_EVENT
                    ],
                },
            ],
        }
    );

    return config;
};

const getMinnesotaConfig = () => {
    const PROOF_OF_EXISTING_COVERAGE_CATEGORY = {
        categoryType: PROOF_OF_EXISTING_COVERAGE,
        documentsQty: 1,
        documentTypes: [
            EXHAUSTION_OF_COBRA_BENEFITS,
            HEALTH_INSURANCE_PROOF
        ],
    };

    const IDENTIFICATION_CATEGORY = {
        categoryType: IDENTIFICATION,
        documentsQty: 1,
        documentTypes: [
            US_PASSPORT,
            STATE_ISSUED_ID,
            DRIVER_LICENSE,
            VOTER_CARD,
        ],
    };

    const ADDRESS_PROOF_CATEGORY = {
        categoryType: ADDRESS_PROOF,
        documentsQty: 2,
        documentTypes: [
            COLLEGE_ENROLLMENT_LETTER,
            AUTOMOBILE_REGISTRATION,
            RENTAL_AGREEMENT,
            HOME_PURCHASE_AGREEMENT,
            UTILITY_BILLS,
            HOME_PAYMENT_NOTICE,
            PROPERTY_TAX_NOTICE,
            OFFER_OF_EMPLOYMENT,
        ],
    };

    const CURRENT_ADDRESS_PROOF_CATEGORY = {
        categoryType: CURRENT_ADDRESS_PROOF,
        documentsQty: 1,
        documentTypes: [
            ...ADDRESS_PROOF_CATEGORY.documentTypes
        ],
    };

    const config = new Map();

    config.set(
        [
            CHANGE_IN_ADDRESS_WITHIN_STATE,
            MOVED_INTO_STATE
        ],
        {
            documents: [
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
                IDENTIFICATION_CATEGORY,
                ADDRESS_PROOF_CATEGORY,
            ],
        }
    );

    config.set(
        [
            MARRIAGE,
            DIVORCE
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_MARRIAGE,
                    documentsQty: 1,
                    documentTypes: [
                        MARRIAGE_CERTIFICATE,
                        COURT_ORDER_PETITION_NAME_CHANGE,
                        DOMESTIC_LEGAL_DOCUMENT,
                        VALIDATION_ON_ID_REPOSITORY,
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
            ],
        }
    );

    config.set(
        [
            DEATH_OF_PTF_OR_SUBSCRIBER,
            DEATH
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_PROOF_OF_DEATH,
                    documentsQty: 1,
                    documentTypes: [
                        DEATH_CERTIFICATE,
                        SIGNED_AFFIDAVIT,
                        OBITUARY
                    ],
                },
            ],
        }
    );

    config.set(
        [
            CHANGE_IN_AI_AN_STATUS,
            CHANGE_IN_TRIBE_STATUS,
            GAIN_IN_TRIBE_STATUS,
            GAIN_OF_AMERICAN_INDIAN_STATUS,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_AIAN,
                    documentsQty: 1,
                    documentTypes: [
                        CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA,
                        TRIBAL_MEMBERSHIP,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            LOSS_OF_MEC,
            LOSE_COVERAGE_NON_PAYMENT,
            LOSE_COVERAGE_NON_PAYMENT_TYPE4,
            LOSE_EMPLOYER_COVERAGE,
            LOSE_EMPLOYER_COVERAGE_TYPE4,
            LOSE_OTHER_PUBLIC_MEC,
            LOSE_OTHER_PUBLIC_MEC_TYPE4,
            LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE,
            LOSS_OF_MEC_FUTURE,
            LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
            PRIMARY_GAIN_OF_MEC,
            PRIMARY_GAIN_OF_MEC_FUTURE,
            CHILD_AGED_OUT_FROM_OLD_APPLICATION,
            EXEMPTION_CANCELLED,
            LOSS_OF_MEDICAID,
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_LOSS_OF_COVERAGE,
                    documentsQty: 1,
                    documentTypes: [
                        TERM_LETTER_FROM_CARRIER,
                        TERM_LETTER_FROM_GOV_PROVIDER,
                        EMPLYR_CONTRI_TERM_FRM_COBRA,
                        EMPLYR_CONTRI_TERM_FRM_EMPLYR,
                        FUND_EXHAUSTION_FM_PERSI,
                        PRIOR_EMPLYR_LOSS_OF_COVERAGE,
                    ],
                },
            ],
        },
    );

    config.set(
        [
            CHANGE_IN_INCARCERATION,
            INCARCERATION,
            NOT_INCARCERATED
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_INCARCERATION_STATUS,
                    documentsQty: 1,
                    documentTypes: [
                        VERIFICATION_OF_TIME_SERVED
                    ],
                },
                {
                    categoryType: PROOF_OF_CONFIRM_CONVICTION_DISPOSITION,
                    documentsQty: 1,
                    documentTypes: [
                        CONFIRM_CONVICTION_DISP_CHARGES
                    ],
                },
            ],
        }
    );

    config.set(
        [
            NEWLY_ELIG_FOR_APTC,
            INCOME_CHANGE_CSR,
            CHANGE_IN_INCOME
        ],
        {
            documents: [
                {
                    categoryType: PROOF_OF_INCOME_CHANGE,
                    documentsQty: 1,
                    documentTypes: [
                        PROOF_OF_INCOME
                    ],
                },
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
                {
                    categoryType: EXCHANGE_CONFIRMATION_OF_APTC,
                    documentsQty: 1,
                    documentTypes: [
                        APTC_ELIG_CONFIRM_LETTER
                    ],
                },
            ],
        }
    );

    config.set(
        [
            OTHER_EXCEPTIONAL_CIRCUMSTANCES
        ],
        {
            documents: [
                {
                    categoryType: DOC_INDICATING_EXCEPTIONS,
                    documentsQty: 1,
                    documentTypes: [
                        REPORT_TO_MILITARY_DUTY,
                        MEDICAL_CONDITIONS,
                        TECHNICAL_ISSUE,
                        OTHER_EXCEPTIONS,
                    ],
                },
            ],
        }
    );

    config.set(
        [
            CHANGE_IN_LEGAL_PRESENCE,
            CHANGE_IN_CITIZENSHIP,
            GAIN_CITIZENSHIP,
            GAIN_LPR,
        ],
        {
            documents: [
                IDENTIFICATION_CATEGORY,
                {
                    ...ADDRESS_PROOF_CATEGORY,
                    mandatoryDocuments: [
                        UTILITY_BILLS
                    ],
                },
            ],
        },
    );

    config.set(
        [
            CHANGE_IN_ADDRESS
        ],
        {
            documents: [
                PROOF_OF_EXISTING_COVERAGE_CATEGORY,
                IDENTIFICATION_CATEGORY,
                CURRENT_ADDRESS_PROOF_CATEGORY,
            ],
        }
    );

    return config;
};

export const documentsVerificationConfig = {
    [states.IDAHO]: getIdahoConfig(),
    [states.PENNSYLVANIA]: getPennsylvaniaConfig(),
    [states.NEVADA]: getNevadaConfig(),
    [states.NEW_JERSEY]: getNewJerseyConfig(),
    [states.VIRGINIA]: getVirginiaConfig(),
    [states.GEORGIA]: getGeorgiaConfig(),
    [states.MINNESOTA]: getMinnesotaConfig()
};

export const TYPES_EXCEPTIONS_FOR_LABELS = {
    SPECIAL_CIRCUMSTANCE_ATTESTATION,
};
